import React from "react";
import "./featuresImg.css";
import wave from './images/wave.png';
import img1 from './images/f-img1.png'
import img2 from './images/f-img2.png'
import img3 from './images/f-img3.png'
import img4 from './images/f-img4.png'
import img5 from './images/f-img5.png'
import img6 from './images/f-img6.png'

const Features = () => {
  const data = [
    {
      img: img1,
      title: "Industry Expert Mentors",
      desc: "Learn Cybersecurity from certified experts with real-world hacking and defense experience.",
    },
   
   
    {
      img: img4,
      title: "Budget-Friendly Learning",
      desc: "Get premium cybersecurity training at an affordable cost with high ROI skills.x",
    },
    
    {
      img: img6,
      title: "100% Career Support",
      desc: "Get job assistance, resume building, and interview preparation with top companies.",
    },
  ];

  return (   
    <div className="features">
          <div className="wave">
            <img src={wave} alt="Wave"/>
             </div> 
        <h1>Why Choose Our Cybersecurity Training?</h1>
        <span>Gain in-demand cybersecurity skills with expert-led training and real-world projects. Learn through hands-on practice, penetration testing, and live scenarios.<br/> Build practical knowledge that makes you job-ready for top tech companies.</span>
      <div className="features-container">
        {data.map((item, index) => (
          <div className="feature-card" key={index}>
            <img src={item.img} alt={item.title} />
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;
